<template>
  <div class="ask-show-comment">
    <div class="comment" v-if="info">
      <van-row class="list" gutter="15">
       <van-col span="3" @click="goMy(info.user.id,info.user.form)">
         <div class="infohand_box">
           <img class="avatar" :src="info.user && info.user.headimg_url&&info.user.headimg_url.substring(0,5)=='https' ? info.user.headimg_url : img.avatar" />
           <img class="infohand_border" :src="img.border_pic" v-if="info.user.auth.is_audit==1">
         </div>

       </van-col>
       <van-col span="21">
        <div class="comm_name">
          <div style="flex: 1">
            {{ info.user.user_name }}
            <div class="sourtime" style="display: flex;align-items: center;" v-if="info.user.cars.id"><img class="member_car" :src="img.member_car">{{info.user.cars.title}} 车主</div>
          </div>
          <span class="binbox">
            <img class="binpic" @click="setCommentPraise(index)" :src="info.is_praise ? img.collect_have : img.collect">
            <span class="sourtime">{{ info.praise_num }}</span>
          </span>
        </div>
        <p v-if="info.content">{{ info.content }}</p>
        <p class="time">{{ info.create_time }}
          <span class="c-black" @click="replysOne()"> · 回复({{ info.reply_num }})</span>
          <span v-if="info.user.id==params.user_id" class="f-r" @click="delComment(info.id)">删除</span>
          <span v-else class="f-r" @click="toTip">举报</span>
        </p>
      </van-col>
    </van-row>
  </div>
  <div class="replys">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="reply">
      <van-row class="list" gutter="15" v-for="reply in replys" :key="'reply_' + reply.id">

       <van-col span="3" @click="goMy(reply.user.id,reply.user.form)">
        <div class="infohand_box">
         <img class="avatar" :src="reply.user && reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" />
         <img class="infohand_border" :src="img.border_pic" v-if="reply.user.auth.is_audit==1">
       </div>

     </van-col>
     <van-col span="21">
       <div class="comm_name">
        <div style="flex: 1">
          {{ reply.user.user_name }}
          <div class="sourtime" style="display: flex;align-items: center;" v-if="info.user.cars.id"><img class="member_car" :src="img.member_car">{{info.user.cars.title}} 车主</div>
        </div>
      </div>
      <p v-if="reply.content"><span v-if="reply.reuser">回复<span class="f-w ml-5">{{ reply.reuser.user_name }}</span>：</span>{{ reply.content }}</p>
      <p class="time">{{ reply.create_time }}
        <span class="c-black" @click="replysTow(reply.id)"> · 回复
          <span v-if="reply.reply_num>0">({{ reply.reply_num }})</span>
        </span>
      </p>
    </van-col>
  </van-row>
</div>
</van-list>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="infop&&infop.reply_num>0">{{infop.reply_num}}</span>
          </span>
        </van-col>
        <van-col span="10" v-if="infop">
          <span class="binbox" @click="Collect(infop.is_praise)">
            <img class="binpic" :src="infop.is_praise==1?img.collect_have:img.collect">
            <span class="num" v-if="infop.praise>0">{{infop.praise}}</span>
          </span>
        </van-col>
        <van-col span="6">
          <span class="binbox" @click="outrelay()">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
     <!--  <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
  <van-popup v-model="showpop" class="userpop">
    <div class="sourcepop">来自{{sourceName}}的评论</div>
    <div @click="closePop">取消</div>
  </van-popup>
</div>
</template>
<script>
  import content from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {List, Row, Col,Field,Button,Overlay,ActionSheet,Divider,Grid,GridItem,Popup} from "vant";

  export default {
    data () {
      return {
       value:'',
       inputshow:true,
       overlay:false,
       inputfocus:false,
       inputnum:14,
       rid:'',
       replytype:0,
       params: {
        page: 1,
        size: 4,
        order: 1,
        user_id: 0
      },
      comment_id: '',
      post_id:'',
      loading: false,
      finished: false,
      info: '',
      infop:'',
      replys: [],
      shareshow:false,
      showpop: false,
      sourceName:'',
      img: {
        avatar: require('../../../assets/img/lexus/default.png'),
        parise: require('../../../assets/img/parise.png'),
        parise_have: require('../../../assets/img/parise_have.png'),
        loading: require('../../../assets/img/loading_lexus.gif'),
        collect: require('../../../assets/img/lexus/collect.png'),
        collect_have: require('../../../assets/img/lexus/collect_have.png'),
        comment: require('../../../assets/img/lexus/comment.png'),
        inrelay: require('../../../assets/img/lexus/inrelay.png'),
        outrelay: require('../../../assets/img/lexus/outrelay.png'),
        friends: require('../../../assets/img/lexus/friends.png'),
        wechat: require('../../../assets/img/lexus/wechat.png'),
        link: require('../../../assets/img/lexus/link.png'),
        poster: require('../../../assets/img/lexus/poster.png'),
        member_car: require('../../../assets/img/member_car.png'),
        border_pic:require('../../../assets/img/lexus/border.gif'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    let id = this.$route.params.id
    this.post_id=this.$route.query.postid
    this.weburl=process.env.VUE_APP_URL
    if(this.$util.isEmpty(id)) {
      this.$toast('评论不存在')
      return false
    }
    this.comment_id = id
    this.getPostinfo()
    this.getInfo()
  },
  activated () {
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      }
    })
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
  },
  watch: {
    '$route'() {
      if(this.$route.params.id != this.comment_id) {
        this.comment_id = this.$route.params.id
        this.getPostinfo()
        this.getInfo()
      }
    }
  },
  methods: {
    setCommentPraise () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.is_praise ? 2 : 1;
        content.setCommentPraise({id: this.info.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.is_praise = 1
            } else {
              this.info.is_praise = 0
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    setReplyPraise (index) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.replys[index].is_praise ? 2 : 1;
        content.setCommentPraise({id: this.replys[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.replys[index].is_praise = 1
              this.replys[index].praise_num += 1
            } else {
              this.replys[index].is_praise = 0
              this.replys[index].praise_num -= 1
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    toTip() {
      this.$toast.success('举报成功')
    },
    getPostinfo () {
      var post_id=this.post_id
      content.getShow(this.post_id).then(res => {
        if(res.data.state == 1) {
          this.infop = res.data.data
          this.$util.title(res.data.data.title)
          var apppar={
            title:res.data.data.title
          }
          this.$appService.changeTitle(apppar)
          
        }
      })
    },
    getInfo () {

      let user_id = this.user ? this.user.id : 0
      var params={
        user_id: this.user ? this.user.id : 0,
        source:this.source
      }
      content.getCommentShow(this.comment_id, params).then(res => {
        if(res.data.state == 1) {
          var info=res.data.data
          var user_name = info.user.user_name
          var arr = user_name.split('[');
          info.user.user_name = arr[0]
          info.user.form = arr[1]
          this.info = info
          var params={
            event_code: '评论详情',
            event_id: this.info.id,
            title: this.info.content,
            value: '',
            path: '/Lexus/Content/ShowComment.vue',
            user_id: this.user ? this.user.id : 0,
            source: this.source
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){
            }
          })
        }
      })
    },
    inputFocus(){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
          member.getMemberInfo({source:this.source}).then(res => {
            if(res.data.state == 1) {
             var binding_status=res.data.data.phone_binding_status.status
             var mobile=res.data.data.mobile
             if(mobile){
              this.inputshow=false;
              this.rid=this.comment_id
              this.replytype=0
              this.overlay=true;
              this.inputnum=19;
              setTimeout(() => {
                var cc=document.getElementById('inputid');
                cc.scrollIntoViewIfNeeded(true);
              },500)
            }else{
              this.$refs.inputTag.blur()
              this.$dialog.confirm({
                title:'温馨提示',
                message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                width:'80%',
                messageAlign:'left',
                confirmButtonText:'去绑定',
              }).then(() => {
               var params={
                url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                isReturn: true 
              }
              this.$appService.openWebView(params)

            }).catch(() => {
             this.inputshow=false;
             this.rid=this.comment_id
             this.replytype=0
             this.overlay=true;
             this.inputnum=19;
             setTimeout(() => {
              var cc=document.getElementById('inputid');
              cc.scrollIntoViewIfNeeded(true);
            },500)
           });

          }
        }
      })
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      
    },
    inputBlur(){
      setTimeout(() => {
        this.inputshow=true;
        this.inputnum=14;
      }, 1000);
      this.overlay=false;
      this.inputfocus=false
    },
    replysTow(rid){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.inputshow=false;
      this.rid=rid
      this.replytype=1
      this.$refs.inputTag.focus()
      this.overlay=true;
      this.inputnum=19;
      this.inputfocus=true
      setTimeout(() => {
        var cc=document.getElementById('inputid');
        cc.scrollIntoViewIfNeeded(true);
      },500)
    },
    replysOne(){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.inputshow=false;
      this.rid=this.comment_id
      this.replytype=0
      this.$refs.inputTag.focus()
      this.overlay=true;
      this.inputnum=19;
      this.inputfocus=true
      setTimeout(() => {
        var cc=document.getElementById('inputid');
        cc.scrollIntoViewIfNeeded(true);
      },500);
    },
    touchstart(){//检测触发遮罩层，失去焦点
      this.inputshow=true;
      this.overlay=false;
      this.$refs.inputTag.blur()
      this.inputnum=14;
      this.inputfocus=false
      this.replytype=0
    },
    post(){
      if(this.replytype==0){
        var params={
          parent_rid:'',
          rid:this.rid,
          archive_id:this.post_id,
          content:this.value
        }
      }else{
        var params={
          parent_rid:this.comment_id,
          rid:this.rid,
          archive_id:this.post_id,
          content:this.value
        }
      }
      content.Comment(params).then(res => {
       if(res.data.state == 1) {
        this.inputshow=true;
        this.$toast.success('发表成功')
        this.value=''
        this.finished = false
        this.replys=[]
        this.params.page = 1
      }
    })
    },
    delComment(id,index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
        content.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500);
          }
        })
      }).catch(() => {});
    },
    onCancel(){
      this.actionshow=false
    },
    outrelay(){
      if(this.infop.module.id==1){
        var type='/post'
      }else if(this.infop.module.id==2){
        var type='/pic'
      }else if(this.infop.module.id==3){
        var type='/video'
      }
      var user_id=this.user?this.user.id:0
      this.shareshow=true
      this.sharetitle=this.infop.title
      this.sharecontent=this.infop.description
      this.shareurl='/pages/article/article?scene='+this.infop.id+'-'+user_id
      this.shareweburl=this.weburl+'/lexus/article/'+this.infop.id+type+'?source='+this.source
      if(this.infop.share_image){
        this.shareimageUrl=this.infop.share_image
      }else{
        this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
      }
    },
    toShare(type){
      if(type==1){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl,
          weburl:this.shareweburl,
          wechatid:'gh_d2c493f1bc41'
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      }else{
        this.$appService.getToken(v => {
          if(v.token) {
            var para={
              source:9,
              id:this.infop.id,
              user_id:this.user.id
            }
            content.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.shareContent(params)
              }
            })
          }else{
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
      }

    },
    goMy(id,from){
      if(from){
        var sourceName = from.substr(0, from.length - 1)
        this.sourceName=sourceName
        this.showpop=true
      }else{
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    closePop(){
      this.showpop=false
    },
    Collect(type){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(type==1){
        var type=2
      }else{
        var type=1
      }
      content.setPraise({id: this.infop.id, type: type}).then(res => {
        if(res.data.state == 1) {
          if(type == 1) {
            this.infop.is_praise = 1
            this.infop.praise += 1
          } else {
            this.infop.is_praise = 0
            this.infop.praise -= 1
          }
        }
      })
    },
    onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      this.params.source = this.source
      // 异步更新数据
      setTimeout(() => {
        content.getCommentReplys(this.comment_id, this.params).then(res => {
          var newlist = res.data.data.data
          for (var i = 0; i < newlist.length; i++) {
            var user_name = newlist[i].user.user_name
            var arr = user_name.split('[');
            newlist[i].user.user_name = arr[0]
            newlist[i].user.form = arr[1]
            var replys = newlist[i].replys
            if (replys) {
              for (var j = 0; j < replys.length; j++) {
                var user_name = replys[j].user.user_name
                var arr = user_name.split('[');
                replys[j].user.user_name = arr[0]
                replys[j].user.form = arr[1]
                var ruser_name = replys[j].reuser.user_name
                var rarr = ruser_name.split('[');
                replys[j].reuser.user_name = rarr[0]
                replys[j].reuser.form = rarr[1]
              }
            }
          }
          this.replys.push.apply(this.replys, newlist)
          this.params.page += 1
          this.loading = false

          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]: List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [Divider.name]:Divider,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [ActionSheet.name]:ActionSheet,
    [Popup.name]:Popup
  }
};
</script>

<style lang="scss">
.ask-show-comment {
  .comment{
    border-bottom: 1px solid #f8f8f8;
    padding: 15px;
  }
  .replys {
    margin-top: 10px;
    padding:0 15px;
    .reply {
      overflow: hidden;
      .ml-5{
        margin-left: 5px;
      }
    }

  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .list {
    padding: 10px 0;
  }
  .avatar {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 1.5px;
  }
  .infohand_box{
    width:40px;
    height:45px;
    position: relative;
  }
  .infohand_border{
   width:40px;
   height:40px;
   position: absolute;
   left: 0;
 }
 .comm_name {
  height: 40px;
  font-size: 14px;
  color:#605c6b; 
  display: flex;
  align-items: center;
  .binbox {
    color: #9A9A9A;
    font-size: 12px;
    float: right;
    font-weight: normal;
    img {
      width: 15px;
      height: 14px;
      margin-right: 11px;
    }
  }

}
h3 {
  font-size: 15px;
  margin: 8px 0;

  .binbox {
    color: #9A9A9A;
    font-size: 12px;
    float: right;
    font-weight: normal;
    img {
      width: 15px;
      height: 14px;
      margin-right: 11px;
    }
  }
}
p {
  font-size: 13px;

  .c-blue {
    font-style: normal;
  }
}
.time {
  font-size: 12px;
  color: #9A9A9A;
}
.bintright {
  text-align:right;
}
a{
  color: #3A3A3A;
}
.van-popup{
  .van-action-sheet__cancel::before{
    height: 1px;
  }
  .divider{
    margin: 20px 80px;
  }
}
}
</style>
